import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';

import { AuthService } from '@bookly/shared';

import { Permission, RoleType } from '../model/role.model';

type AccessInput =
  | { role?: RoleType; permissions?: Permission[] }
  | RoleType
  | Permission
  | Permission[];

@Directive({
  selector: '[bshHasAccess]',
})
export class HasAccessDirective implements OnInit {
  readonly #templateRef = inject(TemplateRef);
  readonly #viewContainer = inject(ViewContainerRef);
  readonly #authService = inject(AuthService);
  private requiredRole?: RoleType;
  private requiredPermissions: Permission[] = [];

  @Input()
  set bshHasAccess(value: AccessInput) {
    if (Array.isArray(value)) {
      this.requiredPermissions = value as Permission[];
    } else if (typeof value === 'object') {
      this.requiredRole = value.role;
      this.requiredPermissions = value.permissions ?? [];
    } else {
      if (Object.values(RoleType).includes(value as RoleType)) {
        this.requiredRole = value as RoleType;
      } else if (Object.values(Permission).includes(value as Permission)) {
        this.requiredPermissions = [value as Permission];
      }
    }
  }

  ngOnInit(): void {
    let hasAccess = false;
    if (this.requiredRole && this.requiredPermissions.length) {
      hasAccess = this.#authService.hasPermissionsInRole(
        this.requiredRole,
        this.requiredPermissions
      );
    } else if (this.requiredRole) {
      hasAccess = this.#authService.hasRole(this.requiredRole);
    } else if (this.requiredPermissions.length) {
      hasAccess = this.#authService.hasPermissions(this.requiredPermissions);
    }
    if (hasAccess) {
      this.#viewContainer.createEmbeddedView(this.#templateRef);
    } else {
      this.#viewContainer.clear();
    }
  }
}
